export const PRODUCT_NAME = Object.freeze({ 
    PATINETAS: 'SeguroPatineta'
});